// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bcm_a big_a big_q big_j big_wl big_bj","ImgResponsive__img":"bcm_b big_b big_ql"};